const TRAVELERS_EDIT_ACCOMPANIES = {
  familyRelationship: "",
  familyRomajiName: "",
  familyRomajiSurname: "",
}

export const InitialValues = {
  TRAVELERS_EDIT_ACCOMPANIES,
}
